import moment from 'moment';
export const useDateFormat = (date) => {
    return moment(date).format("D/MM/YYYY")?.slice(0, 10);
};